<template>
    <div id="content_left" style="width: 100%;height: 100%"></div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: {
        contentLeftData: {
            type: Object,
            default: () => { }
        }
    },
    name: 'contentLeft',
    mounted() {
        const chartContainer = document.getElementById('content_left');
        const chart = echarts.init(chartContainer);
        let price = this.contentLeftData.price
        console.log('price',price)
        const options = {
            title: {
                text: '专利价值分布图',
                left: 'center',
                top: '0',
                textStyle: {
                    color: '#fff',
                    fontSize: 20,
                    fontWeight: 'bold'
                }
            },
            tooltip: {
                trigger: 'axis', // 坐标轴触发
                axisPointer: {
                    type: 'none'
                },
                formatter: function (params) {
                    // 格式化显示内容
                    var res = params[0].name + '万元' + '<br/>';
                    params.forEach(function (item) {
                        res += item.seriesName + '：' + item.value + '件 <br/>';
                    });
                    return res;
                }
            },

            grid: {
                top: 120,
                right: -20,
                left: '1%',
                containLabel: true
            },
            xAxis: {
                name: '数量（件）',
                nameLocation: 'start',
                nameTextStyle: {
                    verticalAlign: 'top',
                    padding: [-40, 0, 0, 0]
                },
                nameGap: -60,
                offset: 30,
                type: 'value',
                position: 'top',
                boundaryGap: [0, 0.01],
                splitLine: {
                    show: false
                },
                splitArea: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#fff'
                    }
                },
                axisLabel: {
                    show: true,
                    color: '#fff'
                }
            },
            yAxis: {
                name: '单位：万元',
                nameTextStyle: {
                    color: '#fff'
                },
                type: 'category',
                nameLocation: 'start',
                data: price,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    show: true,
                    color: '#fff'
                },
            },
            series: [
                {
                    name: '数量',
                    type: 'bar',
                    data: this.contentLeftData.num,
                    showBackground: true,
                    backgroundStyle: {
                        color: 'rgba(76, 143, 250, 0.2)'
                    },
                    itemStyle: {
                        color: (params) => {
                            return this.contentLeftData.color[params.dataIndex]
                        }
                    }
                }
            ]
        };
        chart.setOption(options);
        chart.on('click',function(params){
          let name = params.name
          let newName = ''
          // 判断name的区间
          if(name == '0~10' || name == '10~20'){
              newName = '20万以下'
          }
          if(name == '20~30' || name == '30~40'){
              newName = '20~40(万)'
          }
          if(name == '40~50' || name == '50~60'){
              newName = '40~60(万)'
          }
          if(name == '60~70' || name == '70~80'){
              newName = '60~80(万)'
          }
          if(name == '80~90' || name == '90~100'){
              newName = '80~100(万)'
          }
          if(name == '100~120'){
              newName = '100~120(万)'
          }
          if(name == '120~140'){
              newName = '120~140(万)'
          }
          if(name == '140~160'){
              newName = '140~160(万)'
          }
          if(name == '160~180'){
              newName = '160~180(万)'
          }
          if(name == '180~200'){
              newName = '180~200(万)'
          }
          if(name == '200以上'){
              newName = '200万以上'
          }
          localStorage.setItem('consolePriceInt', newName)
          window.open('#/patent/monitor','_blank')
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/views/console/components/contentLeft.vue